import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import imgLogo from "assets/images/logo.png";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
// Redux
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Admin/AuthService";
import "./login.scss";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "../../../../node_modules/react-toastify";

const Register = (props) => {
  const getRemmberMe=localStorage.getItem("remmberMe")==="false" ? false  :true
  const getEmail=localStorage.getItem("admin_email")

  const [email,setEmail]=useState( getRemmberMe ? getEmail :  "" )
  const [remmberMe,setRemmberMe]=useState( getRemmberMe ? getRemmberMe : false )

   const handleValidSubmit = (event, values) => {
      if(remmberMe){
       localStorage.setItem("remmberMe",remmberMe)
       localStorage.setItem("admin_email",values.email)
 
     }else{
      localStorage.removeItem("remmberMe")
      localStorage.removeItem("admin_email")
     }
     AuthService.login(values).then((res) => {
       // need to return  status  code from backend
      // if (res.code === SuccessOk && AuthService.isAuthenticated()) {
      //   props.history.push(`${adminPrefix}/dashboard`);
      // }
   
        props.history.push(`${adminPrefix}/dashboard`);

    
    }).catch(res=>{
      toast.error(res.error);

    })
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title> Login </title>
      </MetaTags>
      <div className='account-pages'>
        <div className="bgImage">
          <Container fluid>
            <Row className='justify-content-center text-left' dir='rtl'>
              <Col md={8} lg={7} xl={6} className='p-lg-0 p-md-0' dir='ltr'>
                <Card className='overflow-hidden mt-5 mb-3'>
                  <CardBody className="text-center">
                    <img src={imgLogo} className='mt-3' />
                    <p className='fw-bold font-size-18 fw-bold pt-2 mb-2'>Sign Up</p>
                    <p className="textMuted font-size-13">Use you email address and password to can login</p>
                    <div className='p-2'>
                      <AvForm
                        className='form-horizontal formWithLabel'
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v);
                        }}>
                        <div className='mb-3'>
                          <AvField
                            name='firstname'
                            label='First Name'
                            className='form-control mb-3'
                            placeholder='First Name'
                            type='text'
                            required
                          />
                        </div>
                        <div className='mb-3'>
                          <AvField
                            name='lastname'
                            label='Last Name'
                            className='form-control mb-3'
                            placeholder='Last Name'
                            type='text'
                            required
                          />
                        </div>
                        <div className='mb-3'>
                          <AvField
                            name='mobile'
                            label='Mobile Number'
                            className='form-control mb-3'
                            placeholder='+123456789'
                            type='text'
                            required
                          />
                        </div>

                        <div className='mb-3'>
                          <AvField
                            name='password'
                            label='Password'
                            type='password'
                            className='form-control mb-3'
                            placeholder='Enter your Email Password'
                            required
                          />
                        </div>
                        <div className='mb-3'>
                          <AvField
                            name='repassword'
                            label='Pe-Type Password'
                            type='password'
                            className='form-control mb-3'
                            required
                            placeholder='Pe-Type Password'
                          />
                        </div>
                        <div className='mt-4 d-grid'>
                          <button
                            className='btn btn-success btnHeight w-100'
                            type='submit'>
                            Sign Up
                          </button>
                        </div>
                        {/* <div className='mt-4 text-end text-center'>
                          <Link
                            to={`${adminPrefix}/login`}
                            className='textMuted text-decoration-underline'>
                           Do you have Account ? Login now 
                          </Link>
                        </div> */}
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};
export default Register;
// export default withRouter(
//     connect(mapStateToProps, {loginUser, apiError, socialLogin})(Login)
// )
